import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';


// import svg from '../../../../img/symbol.svg'
function PaymentSuccessful(props) {
    const { activeTab } = props.data
    return (
        <div className={`main ${activeTab == 4 ? "active" : ''}`}>
          
            <div className="main-box pay_box">
            <p className='back_home' onClick={()=>props.handleBack()}>{props.isoldPatient?'Check File id':'Back to Personal Information'}</p>
                <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                >
                    <circle
                        className="checkmark__circle"
                        cx={26}
                        cy={26}
                        r={25}
                        fill="none"
                    />
                    <path
                        className="checkmark__check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                </svg>
                <div className="text congrats">
                    <h2>Your payment was successful</h2>
                    <p>
                        Thanks for your payment have been successfully for the
                        future we will contact you soon.
                    </p>
                </div>
            </div>
           
        </div>
    );
}

export default PaymentSuccessful;